import React, { useEffect, useState } from "react";
import {
  IonApp,
  IonCol,
  IonContent,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonLoading,
  IonPage,
  IonRow,
} from "@ionic/react";
import BackButtonTitle from "components/mobile-components/Common/BackButtonTitle";
import { useDispatch, useSelector } from "react-redux";
import RecommendProduct from "components/mobile-components/Home/RecommendProduct";
import Product from "services/Product";
import SingleRecommendProduct from "components/mobile-components/Home/SingleRecommendProduct";
import StarBig from "assets/images/icon/svg/StarBig";
import { digitChanger, numberWithCommas } from "helpers/helper";
import { useNavigate } from "react-router-dom";
import NavFooter from "components/mobile-components/Common/NavFooter";
import TitleNSearch from "components/mobile-components/Common/TitleNSearch";
import StockOutMini from "assets/images/icon/svg/StockOutMini";
import Departments from "components/mobile-components/Home/Departments";
import Department from "services/Department";
import BrandCard2 from "components/mobile-components/Home/BrandCard2";
import Brand from "services/Brand";

export default function ProductsTab({ loading, products }) {
  const ekkLanguage = useSelector((state) => state.lan.lan);
  const navigate = useNavigate();
  const [departmentList, setDepartmentList] = useState([]);
  const [brandData, setBrandData] = useState("");
  const [cardLoading, setCardLoading] = useState(false);

  let getDepartments = async () => {
    let response = await Department.getDepartments();
    if (response.status === 200) {
      setDepartmentList(response.results);
    } else {
      setDepartmentList([]);
    }
  };
  useEffect(() => {
    getDepartments();
  }, []);

  let getBrandList = async () => {
    setCardLoading(true);
    let response = await Brand.getBrandList();
    if (response.status === 200) {
      setCardLoading(false);
      setBrandData(response.results);
    } else {
      setCardLoading(false);
    }
  };
  useEffect(() => {
    getBrandList();
  }, []);

  return (
    <div>
      <div className="pt-5 pb-7">
        <Departments departmentList={departmentList} />
      </div>
      <div className="mb-7 px-2">
        {brandData?.length > 0 && (
          <BrandCard2 slideData={brandData} loading={cardLoading} />
        )}
      </div>

      {loading ? (
        <IonLoading isOpen={loading} message={ekkLanguage.orderList.loader} />
      ) : (
        <div className="pt-3 px-2">
          <IonRow>
            {products?.length ? (
              products.map((el, i) => {
                let isImageLength = () => {
                  if (el?.images?.length) {
                    return `${el?.images[0]}`;
                  } else {
                    if (el?.type === "variant") {
                      return "/assets/images/varient_default.png";
                    } else if (el?.type === "pack") {
                      return "/assets/images/pack_default.png";
                    } else if (el?.type === "offer") {
                      return "/assets/images/offer_default.png";
                    }
                  }
                };
                return (
                  <IonCol size="6" sizeSm="4" className="mb-6" key={i}>
                    <div className="relative overflow-hidden">
                      <div
                        className="text-center flex items-center "
                        onClick={() => navigate(`/product-details/${el?.id}`)}
                      >
                        <div className="product-image-sizer relative rounded-[10px] flex pb-[5px] m-auto">
                          {el?.inventory_quantity <= 0 && (
                            <div className="flex absolute w-[44px] h-[38px] border-2 border-white bg-primary items-center justify-center rounded-br-[10px] rounded-tl-[10px] top-[-2px] left-0 border-l-0">
                              <StockOutMini />
                            </div>
                          )}
                          {Number(el?.profit) > 0 && (
                            <div className="flex absolute w-auto h-[24px] border-2 border-white bg-success items-center justify-center rounded-[10px]  top-0 right-0">
                              <span className="ml-[5px] font-bold text-12 text-white px-1">
                                {el?.country &&
                                  el?.country?.currency_symbol_native}
                                {digitChanger(numberWithCommas(el?.profit))}
                              </span>
                            </div>
                          )}

                          <img
                            className="w-full h-full object-contain flex m-auto mb-[5px]"
                            src={isImageLength()}
                            alt="icon"
                          />
                        </div>
                      </div>
                      <h5 className="font-bold text-14 text-primary mb-[5px]">
                        {el?.country && el?.country?.currency_symbol_native}
                        {digitChanger(numberWithCommas(el?.base_price))}
                      </h5>
                      <h6 className="font-semibold text-14 text-262626-1000 mb-[5px] min-h-[36px]">
                        {el?.name}
                      </h6>
                      <div className="flex justify-between items-center mr-4">
                        <div>
                          <h6 className="font-semibold text-14 text-black-500">
                            {el?.weight} <span>{el?.weight_unit}</span>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </IonCol>
                );
              })
            ) : (
              <>
                <IonCol size="2"></IonCol>
                <IonCol size="8">
                  <div
                    className="text-center flex items-center justify-center"
                    style={{
                      height: "calc(100vh - 420px)",
                    }}
                  >
                    <div>
                      <img
                        className="m-auto mb-[10px] mt-5"
                        src="/assets/images/not-found-file.png"
                        alt="emptyCard"
                      />
                      <p className="text-16 font-normal text-222222 mb-[35px]">
                        {ekkLanguage.orderList.notFound}
                      </p>
                    </div>
                  </div>
                </IonCol>
              </>
            )}
          </IonRow>
        </div>
      )}
    </div>
  );
}
